import { normalizeAdminFrontendPath } from "@/utils/navigation/normalizeAdminFrontendPath";

export const resolveLocalhostAutoLoginUserId = (
  value: string | undefined,
): string => (typeof value === "string" ? value.trim() : "");

export const wasLocalhostTokenHandoffLoaded = (search: string): boolean =>
  new URLSearchParams(search).has("token");

export const resolveProtectedRouteReturnUrl = (
  search: string,
): string | null => {
  const params = new URLSearchParams(search);
  const value = params.get("return_url") ?? params.get("returnUrl");

  if (!value || !value.startsWith("/") || value.startsWith("//")) {
    return null;
  }

  return normalizeAdminFrontendPath(value);
};

export const resolveLocalhostAdminLoginReturnUrl = (args: {
  hash: string;
  pathname: string;
  search: string;
}): string =>
  resolveProtectedRouteReturnUrl(args.search) ??
  normalizeAdminFrontendPath(`${args.pathname}${args.search}${args.hash}`) ??
  "/dashboard";

export const buildLocalhostAdminLoginRequestUrl = (args: {
  apiBaseUrl: string;
  returnUrl: string;
  testUserId: string;
}): string => {
  const requestUrl = new URL("/dev/admin-login-url", args.apiBaseUrl);
  requestUrl.searchParams.set("uid", args.testUserId);
  requestUrl.searchParams.set("return_url", args.returnUrl);
  return requestUrl.toString();
};

export const shouldAttemptLocalhostAutoLogin = (args: {
  autoLoginAttempted: boolean;
  hasRedirectedFromProtectedRoute: boolean;
  hasTokenLoginParam: boolean;
  isAuthLoading: boolean;
  isLoginRoute: boolean;
  localTestUserIdConfigured: boolean;
  userPresent: boolean;
}): boolean => {
  if (
    !args.localTestUserIdConfigured ||
    args.userPresent ||
    args.isAuthLoading
  ) {
    return false;
  }

  if (args.autoLoginAttempted || args.hasTokenLoginParam) {
    return false;
  }

  if (args.isLoginRoute && !args.hasRedirectedFromProtectedRoute) {
    return false;
  }

  // Protected localhost routes wait for one Admin-token handoff instead of
  // flashing the manual login page first.
  return true;
};

export const shouldRepairLocalhostAdminSession = (args: {
  claimCheckFailed: boolean;
  hasAdminClaim: boolean;
  isCheckingClaims: boolean;
  isLocalhost: boolean;
  repairAlreadyAttempted: boolean;
  testUserId: string;
  userId: string | undefined;
}): boolean =>
  args.isLocalhost &&
  !args.claimCheckFailed &&
  !args.hasAdminClaim &&
  !args.isCheckingClaims &&
  !args.repairAlreadyAttempted &&
  args.testUserId.length > 0 &&
  args.userId === args.testUserId;
